





import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DamageStatus, IDamage } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component({
  name: 'damage-status-badge',
  components: {},
})
export default class DamageStatusBadge extends Vue {
  @Prop({ required: false, type: Object })
  damage!: IDamage;

  @Prop({ required: false, type: String })
  damageStatus!: DamageStatus;

  @Prop({ required: false, type: Boolean, default: false })
  short!: boolean;

  get status() {
    return this.damage ? this.damage.status : this.damageStatus;
  }

  get label() {
    if (!this.status) return '';
    const l = Util.formatDamageStatus(this.status) || '';
    return this.short ? (l ? l.substr(0, 1) : '') : l;
  }

  get clazz() {
    return Util.formatDamageStatusClass(this.status);
  }
}
